angular.module(ApplicationConfiguration.applicationModuleName).directive('dateAfterOrEqualValidate', [function () {

  	var link = function ($scope, $element, $attrs, ctrl) {

  		var validate = function (viewValue) {
  			var dateModel = $attrs.dateModel;
  			var comparisonModel = $attrs.dateAfterOrEqual;
  			var validationEnabled = ($attrs.dateValidateEnabled === undefined || $attrs.dateValidateEnabled === "true");

  			if (!dateModel || !comparisonModel || !validationEnabled) {
  				ctrl.$setValidity('date-after-or-equal', true); // Válido pois não há o que comparar, ou pois o parâmetro validationEnable é igual a false
  			}
  			else
			{
  				var date = moment(dateModel, 'YYYY-MM-DD');
  				var dateToCompare = moment(comparisonModel, 'YYYY-MM-DD');

  				if (!date.isValid() || !dateToCompare.isValid())
  					ctrl.$setValidity('date-after-or-equal', true); // Válido caso alguma das datas não seja válida, pois não há como comparar
				else  			
  					ctrl.$setValidity('date-after-or-equal', date.isSameOrAfter(dateToCompare)); // Válido caso a data seja menor que a data para se comparar
  			}

  			return viewValue;
  		};

  		ctrl.$parsers.unshift(validate);
  		ctrl.$formatters.push(validate);

  		$attrs.$observe('dateAfterOrEqual', function (comparisonModel) {
  			return validate(ctrl.$viewValue); 
  		});
  	};

  	return {
  		require: 'ngModel',
  		link: link
  	};
  }
]);